const TH = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%2085.333%20512%20341.333'%3e%3crect%20y='85.334'%20fill='%23FFFFFF'%20width='512'%20height='341.326'/%3e%3crect%20y='194.056'%20fill='%230052B4'%20width='512'%20height='123.882'/%3e%3cg%3e%3crect%20y='85.334'%20fill='%23D80027'%20width='512'%20height='54.522'/%3e%3crect%20y='372.143'%20fill='%23D80027'%20width='512'%20height='54.522'/%3e%3c/g%3e%3c/svg%3e";
export {
  TH as default
};
//# sourceMappingURL=TH.svg.es.js.map
